module.exports = __webpack_public_path__ + "img/sticker-cat.15880fe7.webp";